import { createPopper } from '@popperjs/core'
import { onMounted, ref, watch, nextTick } from 'vue'

import vSelect from 'vue-select'
import Cross from '~/components/icons/Cross.vue'

export default {
  __name: 'BaseSelect',
  props: {
  id: {
    default: '',
    type: String
  },
  label: {
    default: '',
    type: String
  },
  placeholder: {
    default: 'Выберите город',
    type: String
  },
  modelValue: {
    type: Object,
    default: () => ({})
  },
  isError: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  masked: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: 'large'
  },
  options: {
    type: Array,
    default: () => []
  },
  isRow: {
    type: Boolean,
    default: false
  },
  errorMessage: {
    type: String,
    default: 'Данные введены неверно'
  },
  searchable: {
    type: Boolean,
    default: false
  },
  adaptiveWidth: {
    type: Boolean,
    default: false
  },
  noOptionLabel: {
    type: String,
    default: 'Подходящих опций не найдено'
  }
},
  emits: [
  'update:model-value'
],
  setup(__props, { emit }) {

const props = __props;

vSelect.props.components.default = () => ({
  Deselect: Cross
})





const handleInput = (ev) => {
  if (ev === props.modelValue) { return }
  if (!ev) {
    emit('update:model-value', { value: '' })
    return
  }

  emit('update:model-value', ev)
}

const opened = ref(false)
const selectLabelEl = ref()
const activeOption = ref()
let maxWidth = -1
const tesf = ref()

onMounted(async () => {
  await nextTick()
  if (!props.adaptiveWidth) { return }

  const adjustWidth = () => {
    const el = selectLabelEl.value
    const elRect = el.getBoundingClientRect()
    if (maxWidth === -1) { maxWidth = elRect.width - 13 }

    const textEl = activeOption.value
    const textElRect = textEl.getBoundingClientRect()

    if (!(elRect.width > textElRect.width)) { return }
    el.style = `width: ${textElRect.width + 22 + 13}px;`
  }

  adjustWidth()

  watch(() => opened.value, (value) => {
    if (value) {
      selectLabelEl.value.style = `width: ${maxWidth}px`
      return
    }

    adjustWidth()
  })
})

const withPopper = (dropdownList, component, { width }) => {
  dropdownList.style.width = width
  dropdownList.classList.add(props.searchable ? 'vs--searchable__list' : 'vs--unsearchable__list')
  const popper = createPopper(component.$refs.toggle, dropdownList, {
    placement: 'bottom',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 10]
        }
      },
      {
        name: 'toggleClass',
        enabled: true,
        phase: 'write',
        fn ({ state }) {
          component.$el.classList.toggle(
            'drop-up',
            state.placement === 'top'
          )
        }
      }
    ]
  })

  return () => popper.destroy()
}


return { __sfc: true,props, emit, handleInput, opened, selectLabelEl, activeOption, maxWidth, tesf, withPopper, vSelect }
}

}